(function () {
    'use strict';

    angular.module("imApp").factory("productionRoutingAddService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3656,
                    parameters: parms || {}
                });
            },
            listProductionRoutings: function (parms) {
                return $ihttp.post({
                    method: 3658,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
